import React from "react";

const HairStraighteningProcess = () => {
  return (
    <div className="hairSalonInSahakaraWhat">
      <h3>The Hair Straightening Process at SCENT</h3>
      <p>
        When you visit SCENT, you’ll be taken through a professional and
        detailed hair straightening process that guarantees outstanding results.
        Here’s what to expect when you choose our hair straightening salon in
        Bangalore:
      </p>
      <li>
        <h6>1. Initial Consultation</h6>
        <p>
           During the consultation, our hair experts
          assess your hair’s texture, condition, and history of chemical
          treatments. This allows us to recommend the most suitable hair
          straightening method for you.
        </p>
      </li>
      <li>
        <h6> 2. Pre-Treatment Preparation</h6>
        <p>
          We prepare your hair for straightening by
          cleansing it thoroughly to remove impurities. This step is crucial to
          ensure that the treatment penetrates your hair effectively for optimal
          results.
        </p>
      </li>
      <li>
        <h6>3. Application of Straightening Solution</h6>
        <p>
           Based on the treatment
          selected, our stylists apply a high-quality straightening solution
          that works on your hair’s natural bonds. For instance, rebonding
          treatments require a solution that alters the hair’s structure, while
          keratin treatments infuse keratin protein into each strand.
        </p>
      </li>
      <li>
        <h6> 4. Heat Processing</h6>
        <p>
           To lock in the treatment, our experts use flat
          irons or other heat tools. This step solidifies the straightening
          process and ensures that your hair remains sleek and smooth for
          months.
        </p>
      </li>
      <li>
        <h6> 5. Final Rinse and Conditioning</h6>
        <p>
          After the heat processing, your hair
          is thoroughly rinsed and conditioned with nourishing products. This
          step not only removes any residual chemicals but also leaves your hair
          shiny and healthy.
        </p>
      </li>
      <li>
        <h6> 6. Aftercare Guidance</h6>
        <p>
          SCENT’s experts provide you with comprehensive
          aftercare advice to help maintain your straightened hair for as long
          as possible. Proper aftercare is essential to prolong the effect of
          your hair straightening salon in Bangalore treatment.
        </p>
      </li>
    </div>
  );
};

export default HairStraighteningProcess;
